// document.addEventListener('DOMContentLoaded', function() {
//   var gridIcon = document.querySelector('.icon-grid');
//   var listIcon = document.querySelector('.icon-list');
//   var collectionsView = document.querySelector('.collections-view');
//   var collectionsGrid = document.querySelector('.collections-grid');
//   var collectionsList = document.querySelector('.collections-list');
 
//   if (window.innerWidth <= 767) {
//     collectionsView.classList.add('grid-view');
//     collectionsView.classList.remove('list-view');
//     collectionsGrid.style.display = 'flex';
//     collectionsList.style.display = 'none';
//   }
 
//   collectionsView.classList.add('list-view');
//   collectionsView.classList.remove('grid-view');
//   collectionsGrid.style.display = 'none';
//   collectionsList.style.display = '';

//   gridIcon.addEventListener('click', function() {
//     gridIcon.classList.add('active');
//     listIcon.classList.remove('active');
//     collectionsView.classList.add('grid-view');
//     collectionsView.classList.remove('list-view');
//     collectionsGrid.style.display = '';
//     collectionsList.style.display = 'none';
//   });

//   listIcon.addEventListener('click', function() {
//     listIcon.classList.add('active');
//     gridIcon.classList.remove('active');
//     collectionsView.classList.add('list-view');
//     collectionsView.classList.remove('grid-view');
//     collectionsGrid.style.display = 'none';
//     collectionsList.style.display = ''; 
//     if (window.innerWidth > 767 && window.jQuery && typeof jQuery.fn.slick === 'function') {
//         if (!jQuery('.list-slider').hasClass('slick-initialized')) {
//             jQuery('.list-slider').slick({
//             slidesToShow: 4,
//             slidesToScroll: 4,
//             prevArrow: jQuery('.list-prev'),
//             nextArrow: jQuery('.list-next'),
//             infinite: false
//             });
//         }
//     }

//   });
 
//   if (window.jQuery && typeof jQuery.fn.slick === 'function') {
//     if (!jQuery('.list-slider').hasClass('slick-initialized')) {
//       jQuery('.list-slider').slick({
//         slidesToShow: 4,
//         slidesToScroll: 4,
//         prevArrow: jQuery('.list-prev'),
//         nextArrow: jQuery('.list-next'),
//         infinite: false,
//         adaptiveHeight: false
//       });
//     }
//   }
// });

document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth <= 767) {
    const items = document.querySelectorAll(".collection-item");
    items.forEach(item => {
      item.addEventListener("click", function (e) {
        e.stopPropagation();
        items.forEach(el => el.classList.remove("clicked"));
        this.classList.add("clicked");
      });
    });

    document.body.addEventListener("click", () => {
      items.forEach(el => el.classList.remove("clicked"));
    });
  }
});
